import styled from "styled-components";

export const HomeWrapper = styled.div`
  width: 90%;
  margin: 6rem auto;
  max-width: 1470px;
  padding: 6rem 0 0 0;
  position: relative;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70vh;

    .first-child {
      width: 100%;

      h1 {
        font-size: clamp(3rem, 4vw, 5.1rem);
        color: ${({ theme }) => theme.colors?.side};
        font-weight: 600;
        margin-bottom: 4rem;
        line-height: 1.25;
      }
      h2 {
        font-size: clamp(1rem, 2.8vw, 1.3rem);
        color: ${({ theme }) => theme.colors?.side};
        margin-top: -2rem;
        font-weight: 500;
      }
    }
  }

  .imgWrapper {
    width: 100%;
    max-width: 740px;
    display: flex;
    justify-content: end;

    img {
      width: 110%;
      /* box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2); */
    }
  }

  .certifications-awards {
    margin: 4rem 0 1rem;

    h2 {
      margin: 0;
      font-size: clamp(1.6rem, 3vw, 2.25rem);
      color: ${({ theme }) => theme.colors?.side};
      font-weight: 600;
    }

    p {
      margin: 0.9rem 0 2rem;
      max-width: 780px;
      line-height: 1.6;
      color: ${({ theme }) => theme.colors?.side};
      opacity: 0.88;
    }
  }

  .certifications-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.2rem;
  }

  .certificate-card {
    background: #fff;
    border-radius: 12px;
    overflow: visible;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    transition: transform 220ms ease, box-shadow 220ms ease;

    .certificate-media {
      height: 240px;
      overflow: hidden;
      background: #f4f5f8;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      transition: height 220ms ease;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transform: scale(1);
      transition: transform 220ms ease, object-fit 220ms ease;
      transform-origin: center;
    }

    .certificate-content {
      padding: 1rem 1rem 1.15rem;

      h3 {
        margin: 0;
        font-size: 1.05rem;
        color: ${({ theme }) => theme.colors?.side};
      }

      p {
        margin: 0.45rem 0 0;
        font-size: 0.92rem;
        line-height: 1.5;
        color: ${({ theme }) => theme.colors?.side};
        opacity: 0.84;
      }
    }

    &:hover {
      transform: translateY(-4px);
      z-index: 2;
      box-shadow: 0 18px 34px rgba(0, 0, 0, 0.15);
    }

    &:hover .certificate-media {
      height: 380px;
    }

    &:hover img {
      object-fit: contain;
      transform: scale(1.02);
    }
  }

  @media screen and (max-width: 790px) {
    width: 98%;
    margin: auto;

    .top {
      display: block;
      height: 58vh;
    }

    .top .first-child h1 {
      margin-top: 3rem;
      margin-bottom: 2.5rem;
    }
    /* padding: 7rem 0px 3rem 55px; */

    .imgWrapper {
      margin: auto;
      width: 100%;
      text-align: center;

      img {
        transform: translateY(4rem);
        width: 100%;
      }
    }

    .certifications-awards {
      margin-top: 2.4rem;

      p {
        margin-bottom: 1.4rem;
      }
    }

    .certifications-grid {
      grid-template-columns: 1fr;
      gap: 0.9rem;
    }

    .certificate-card {
      .certificate-media {
        height: 220px;
      }

      &:hover .certificate-media {
        height: 320px;
      }
    }
  }

  /* @keyframes spin {
      from {
         transform: rotate(0deg);
      }
      to {
         transform: rotate(360deg);
      }
   } */
`;
